import { Maybe } from 'graphql/jsutils/Maybe'
import { ProductItemComponentType, ProductItemType, ProductVariantType } from '~/@types/models'

import { isCircularRug, isRunnerRug } from '~/utils/product-variant'

export const getProductImage = (
  product: ProductItemComponentType | ProductItemType,
  handle?: string
) => {
  if (!handle) return null
  switch (handle) {
    case 'runners':
      return product.mainImageRunners
    case 'circular':
      return product.mainImageCircular
    default:
      return product.mainImage
  }
}

export const getProductVariant = (
  product: ProductItemComponentType | ProductItemType
): Maybe<ProductVariantType> => {
  // todo - refactor
  if (product.isRunnerOrCircularRug) {
    return product.variants.find(variant => {
      return isRunnerRug(variant) || isCircularRug(variant)
    })
  }

  return null
}

export const getParamsFromUrl = (collectionHandle: string) => {
  if (typeof window === 'undefined') {
    return
  }

  const searchParams = new URLSearchParams(window.location.search)

  if (!searchParams.size) {
    return
  }

  const bsolFilters = {
    type: collectionHandle,
    filters: {},
  }

  for (const [key, value] of searchParams.entries()) {
    const _filters = value.split(';')
    const filters: any = []

    if (_filters.length > 1) {
      _filters.forEach((_filter: any) => {
        filters.push({ name: _filter, value: _filter })
      })
    }

    bsolFilters.filters = {
      [key]: filters,
    }
  }

  // eslint-disable-next-line consistent-return
  return bsolFilters
}

const extractFileNameFromUrl = url => {
  try {
    // Usando URL para parse seguro da string
    const urlObj = new URL(url)
    // Pegando o pathname e quebrando em partes
    const pathParts = urlObj.pathname.split('/')
    // Encontrando o nome do arquivo (última parte do path)
    const fileName = pathParts[pathParts.length - 1]
    // Removendo a extensão e parâmetros de query
    return fileName.split('.')[0]
  } catch (e) {
    // Fallback caso a URL seja inválida
    console.warn('Invalid URL format:', url)
    return ''
  }
}

export const buildFakeProducts = (edge: any) => {
  let products = edge

  const haveFakeProducts = !!edge.metafields?.fakeProducts?.references?.edges?.length

  if (haveFakeProducts && !products.length) {
    const _fakeProducts = edge.metafields?.fakeProducts?.references?.edges
    const fakeProducts = _fakeProducts?.map(edge => ({
      id: edge.node.image.id,
      shopifyId: edge.node.image.id,
      title: extractFileNameFromUrl(edge.node.image.originalSrc),
      handle: extractFileNameFromUrl(edge.node.image.originalSrc),
      description: '',
      descriptionHtml: '',
      collections: [],
      variants: [],
      productType: '',
      pairsWellWith: [],
      tags: [],
      template: '',
      inStock: true,
      availableForSale: true,
      images: [],
      mainImage: {
        originalSrc: edge.node.image.originalSrc,
        srcLargeDesktop: edge.node.image.srcLargeDesktop,
        srcDesktopMedium: edge.node.image.srcDesktopMedium,
        srcDesktop: edge.node.image.srcDesktop,
        srcMobile: edge.node.image.srcMobile,
        srcMobileSmall: edge.node.image.srcMobileSmall,
        srcSmall: edge.node.image.srcSmall,
        srcXSmall: edge.node.image.srcXSmall,
        altText: edge.node.image.altText || extractFileNameFromUrl(edge.node.image.originalSrc),
      },
      priceRange: {
        minVariantPrice: {
          amount: '0.00',
          currencyCode: 'USD',
        },
        maxVariantPrice: {
          amount: '0.00',
          currencyCode: 'USD',
        },
      },
      compareAtPriceRange: {
        minVariantPrice: {
          amount: '0.00',
          currencyCode: 'USD',
        },
        maxVariantPrice: {
          amount: '0.00',
          currencyCode: 'USD',
        },
      },
      hasMultipleVariants: false,
      isRunnerOrCircularRug: false,
      labels: {
        newArrival: false,
      },
      isFake: true,
    }))
    products = fakeProducts
  }

  return products
}
